var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.trackingDevice)?_c('div',[_c('v-simple-table',{scopedSlots:_vm._u([{key:"default",fn:function(){return _vm._l((_vm.vehicleInformation),function(info){return _c('tbody',{key:info.label},[_c('tr',[_c('td',[_vm._v(_vm._s(info.label))]),_c('td',[_vm._v(_vm._s(info.value))])])])})},proxy:true}],null,false,1406278128)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }